module.exports = __webpack_public_path__ + "media/images/products/retailers-product-4-tweets-6b620d530ee0f4cc8dd0729e012bf825.jpg";